import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-sign-in-step-saler-property',
  templateUrl: './sign-in-step-saler-property.component.html',
  styleUrls: ['./sign-in-step-saler-property.component.scss'],
})
export class SignInStepSalerPropertyComponent {
  @Input() propertyForm!: FormGroup;
  @Input() submited = false;
  @Input() propertyTypes: any[] = [];
  @Input() language = '';
  @Input() isLoadingSubmit = false;

  @Output() ocupationToggle = new EventEmitter<void>();
  @Output() goToStep = new EventEmitter<number>();
  @Output() submit = new EventEmitter<void>();

  onOcupationToggle(): void {
    this.ocupationToggle.emit();
  }
}
